export default __webpack_public_path__ + "static/media/IMG-20210326-WA0038.2935cc18.jpg";